import { List, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const { Option } = Select;

const PublicHolidayBar = ({ holidays }) => {
  const [filteredHolidays, setFilteredHolidays] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(dayjs().format("MM"));
  const [selectedYear, setSelectedYear] = useState(dayjs().format("YYYY"));

  useEffect(() => {
    // Format holidays and filter based on selected month and year
    const formattedList = holidays.map((holiday) => ({
      ...holiday,
      date: dayjs(holiday.StartDate), // Use StartDate as the date field
      name: holiday.HolidayName, // Map HolidayName to name for consistency
    }));

    // Filter holidays based on the selected month and year
    const selectedMonthYearHolidays = formattedList.filter(
      (holiday) =>
        dayjs(holiday.date).format("MM-YYYY") === `${selectedMonth}-${selectedYear}`
    );

    // console.log("Filtered Holidays:", selectedMonthYearHolidays);
    setFilteredHolidays(selectedMonthYearHolidays);
  }, [holidays, selectedMonth, selectedYear]);

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
        <Select
          value={selectedMonth}
          onChange={handleMonthChange}
          style={{ width: 120 }}
        >
          {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
            <Option key={month} value={String(month).padStart(2, "0")}>
              {dayjs().month(month - 1).format("MMMM")}
            </Option>
          ))}
        </Select>

        <Select
          value={selectedYear}
          onChange={handleYearChange}
          style={{ width: 80 }}
        >
          {Array.from({ length: 10 }, (_, i) => i + dayjs().year()).map((year) => (
            <Option key={year} value={String(year)}>
              {year}
            </Option>
          ))}
        </Select>
      </div>

      <List
        loading={false}
        itemLayout="horizontal"
        dataSource={filteredHolidays}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <div
                  style={{ height: "65px", width: "60px" }}
                  className="border-4 border-indigo-500/75 text-center"
                >
                  <h3 className="text-xl font-medium txt-color-2">
                    {dayjs(item.date).format("DD")}
                  </h3>
                  <h3 className="text-base font-medium txt-color-secondary">
                    {dayjs(item.date).format("MMM")}
                  </h3>
                </div>
              }
              title={
                <p className="text-base font-medium text-blue ml-4">{item.name}</p>
              }
              description={
                <div className="ml-4">
                  <p className="text-sm text-gray-500">
                    {dayjs(item.date).format("DD/MM/YYYY")}
                  </p>
                  {item.IsRestricted && (
                    <p className="text-sm text-gray-500">Restricted Holiday</p>
                  )}
                </div>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default PublicHolidayBar;